import { render, staticRenderFns } from "./ManageRequests.vue?vue&type=template&id=7c572c3a&"
import script from "./ManageRequests.vue?vue&type=script&lang=js&"
export * from "./ManageRequests.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequests.vue?vue&type=style&index=0&id=7c572c3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports